import React from 'react';
import { useTheme } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Badge } from '@ui-library/badge';
import { SmallText } from '@ui-library/typography';

import { getAuthTypeIcon } from './utils';
import { useDesignVariant } from '../designVariantContext';

interface AuthTypeBadgeProps {
  label: string;
  icon: string;
}

export const AuthTypeBadge: React.FC<AuthTypeBadgeProps> = ({ label, icon }) => {
  const theme = useTheme();
  const variant = useDesignVariant();

  return (
    <Badge
      size="small"
      bgColor={variant ? theme.token.next.palette.grey50 : theme.token.next.palette.grey0}
      borderColor={variant ? theme.token.next.colorBorder : theme.token.colorBorderSecondary}
      label={
        <SmallText
          color={variant ? theme.token.next.palette.grey700 : theme.token.colorPrimaryText}
          fontWeight={500}
          className="text-nowrap"
        >
          {label}
        </SmallText>
      }
      icon={
        <FontAwesomeIcon
          icon={getAuthTypeIcon(icon)}
          color={variant ? theme.token.next.palette.grey700 : theme.token.colorPrimaryBase}
          size="sm"
        />
      }
      variant={variant}
    />
  );
};
